import {Alignment} from 'analyses/Analyses';
import SequenceAlignmentTabState, {
  SequenceAlignmentTabStateAttributes,
} from 'molbio/tabstates/SequenceAlignmentTabState';
import * as vo from 'settings/visibility-options/VisibilityOptions';

function hideExtraneousVisibilityOptions(visibilityOptions: vo.VisibilityOptions): void {
  for (const optionToHide of [
    vo.TRACE,
    vo.TRACE_QUALITY,
    vo.ALIGNMENT_BASE_QUALITY_CAPITALIZATION,
    vo.VOTES,
    vo.ALIGNMENT_COMMENTS,
  ]) {
    const option = visibilityOptions.getOption(optionToHide.name)!;
    option.set({visible: false, editable: false}, {silent: true});
  }
}

/**
 * A read-only tab state for visually viewing the difference between two sequences,
 * with edits disabled and no trace data or votes.
 */
export default class DiffOnlySequenceAlignmentTabState extends SequenceAlignmentTabState {
  initialize(attributes: Partial<SequenceAlignmentTabStateAttributes>, options?: {}): void {
    super.initialize(attributes, options);
    hideExtraneousVisibilityOptions(this.get('visibilityOptions'));
  }

  msVisibilityOptions(alignment: Alignment): vo.VisibilityOptions {
    const visibilityOptions = super.msVisibilityOptions(alignment);
    hideExtraneousVisibilityOptions(visibilityOptions);
    return visibilityOptions;
  }

  topVisibilityOptions(): vo.VisibilityOptions {
    const visibilityOptions = super.topVisibilityOptions();
    hideExtraneousVisibilityOptions(visibilityOptions);
    return visibilityOptions;
  }

  handleCanEdit(isMasterSequence: boolean, {isFeatureEdit}: {isFeatureEdit?: boolean} = {}): boolean {
    return false;
  }
}
